module.exports = __webpack_public_path__ + "media/images/brand-0a2e46a74ac48d9a4cd892fb5291fcba.png";